// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Mn-z","slideIn":"Nn-z"};